<template>  
<div>
  <div class="special-hero" :style="`backgroundImage: url(${block.image})`" v-if="$mq !== 'mobile' && $mq !== 'tablet'">
    
    <div class="special-hero__wrapper" >
      <div class="special-hero__special-body">
        <div class="special-hero__headline-1"><h1>{{block.headline1}}</h1></div>
        <div class="special-hero__headline-2"><h2 v-html="block.headline2"></h2></div>
        <div class="special-hero__button-container button button--primary" v-if="block.enableCta">
          <a :href="block.ctaUrl" :title="block.ctaText"  class="special-hero__banner-headlink-link">{{block.ctaText}}</a>    
        </div>
      </div>
    </div>
  </div>

  <div class="special-hero__wrapper" v-if="$mq == 'mobile' || $mq == 'tablet'">
    <img :src="block.mobileImage" class="special-hero__mobile-banner" />
    <div class="special-hero__special-body">
      <div class="special-hero__headline-1"><h1>{{block.headline1}}</h1></div>
      <div class="special-hero__headline-2"><h2 v-html="block.headline2"></h2></div>
      <div class="special-hero__button-container button button--primary" v-if="block.enableCta">
        <a :href="block.ctaUrl" :title="block.ctaText"  class="special-hero__banner-headlink-link">{{block.ctaText}}</a>    
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { scrollToElement } from '@/scripts/helpers/util.js';
export default {
  name: 'SpecialImageBannerBlock',
  props: {
    block: Object
  },
  mounted () {

  },
  methods: {
    scrollToContactForm () {
      const toScrollTo = document.querySelector('#contact-us__section-wrap');
      scrollToElement(toScrollTo);
    }
  }
}
</script>

<style lang="scss">
  .special-hero {
    height: 487px;
    background-size: cover;
    background-repeat: no-repeat;

    @include mobile-only{
        height: 338px;
    }
    &__mobile-banner {
      width:100%;
      max-height: 406px;
    }
    
    &__wrapper {
      margin: 0 auto;
      height: 100%;
      max-width: 1441px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      

      @include tablet-up {
        max-width: 100%;
      }
    }

    &__special-body {
      position: relative;
      max-width: 793px;
      margin: 0 auto;
      text-align: center;
      @include mobile-only {
        padding-top: 22px;
        padding-bottom: 51px;
        background: #F6F3F0;
        margin-left: 0px;
        margin-right: 0px;
      } 
      
    }

    &__headline-1 h1 {
      color: $color-black-700;
      font-family:  $font-family-primary;
      font-size: 66px;
      letter-spacing: 4.5px;
      line-height: 34px;
      transform: translateY(.5em);

      @include tablet-up {
        transform: translateY(.4em);
      }

      @include mobile-only {
        font-size: 42px;
        letter-spacing: 0.5px;
      }
    } 

    &__headline-2 h2 {
      transform: translateY(-.3em);
      text-align: center;
      color: $color-brand-primary;
      font-family:  $font-family-global;
      font-size: 15px;
      letter-spacing: 0;
      line-height: 60px;
      margin-top: 30px;

      @include mobile-only {
        font-size: 15px;
        line-height: 34px;
        padding: 13px;
      }
    }

    &__button-container {
      box-sizing: border-box;
      width: 147px;
      padding: 12.5px 13.5px 12.5px 13.5px;
      margin: 0 auto;
    }

    &__banner-headlink-link {
      height: 21px;
      width: 120px;
      color: $color-brand-primary;
      font-family: $font-family-primary;
      font-size: 18px;
      letter-spacing: 0.2px;
      line-height: 20px;
      text-align: center;
      text-decoration: none;
    }

    .ratio-image {
      height: 0;
    }
  }
</style>
